<template>
    <div>
    <Toolbar class="mb-1">
            <template v-slot:start>
                <Button
                  
                  icon="pi pi-plus"
                  
                  @click="openNew"
                />
            </template>
            <template v-slot:end>
                <!-- <FileUpload
                mode="basic"
                accept="image/*"
                :maxFileSize="1000000"
                label="Import"
                chooseLabel="Import"
                class="mr-2 inline-block"
              /> -->
            </template>
        </Toolbar>
    <div class="" style="height:600px;overflow:scroll">
        <!-- {{userlist}} -->
		<div  class="col-12 lg:col-6 xl:col-12"  v-for="(data,key) in userlist" :key="key" >
			<!-- <div  > -->
                <br>
			<div class="card mb-0" style="color:white;background-color:#173EA3;font-size:12px;line-height:0.9" >
				<!-- {{data}} -->
				<div class="grid">
					<div class="col-2 md:col-2">
						<Button
                  icon="pi pi-pencil"
                  title="Edit Group"
                  class="p-button-rounded p-button-success mr-2"
                  @click="edit(data)"
                />
					</div>
					<div class="grid col-4 md:col-10">
						<div class="col-6 md:col-6">
							<span>User Name : </span><span style="text-align:right"><b>{{data.user_name.toUpperCase()}}</b></span>
						</div>
							<div class="col-6 md:col-6">
							<span>Mobile Number : </span><b>{{data.mobile_number}}</b>
						</div>
						<div class="col-6 md:col-6">
							<span>status : </span><b>{{data.status}}</b>
						</div>

					</div>
						
				</div>
				<!-- <span class="text-green-500 font-medium">24 new </span>
				<span class="">since last visit</span> -->
			</div>
			<!-- </div> -->
		
		</div>
		
		<div class="col-12" v-if="list==''" style="text-align:left">
            <br>	
			Data Not Found
		</div>
    </div>
    <Sidebar
            v-model:visible="edit_productDialog"
            :baseZIndex="1000"
            position="full"
          >
          <div class="col-12">
              <div class="card">
                <h5>Update User</h5>
                <hr />
                <div class="p-fluid formgrid grid">
                    <div class="field col-12 md:col-4">
                    <label for="name" v-if="group_type=='School'">Student Name</label>
                    <label for="name" v-else>User Name</label>
                    <InputText
                      id="name"
                      type="text"
                      v-model.trim="name"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !name }"
                    />
                  </div>
                  <div class="field col-12 md:col-2">
                    <label for="name">Mobile Number</label>
                    <InputText
                      id="name"
                      type="text"
                      size="10"
                      @keypress="isNumberKey($event)"
                      v-model.trim="mobile_number"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !mobile_number }"
                    />
                  </div>
                  <div class="field col-12 md:col-2">
                    <label for="status">Status</label>
                    <Dropdown
                      id="status"
                      v-model="selectstatus"
                      :options="dropdownItems"
                      :value="dropdownItems.value"
                      optionLabel="name"
                      placeholder="Select One"
                      @change="change_status"
                      :class="{ 'p-invalid': submitted && !selectstatus }"
                      required="true"
                    ></Dropdown>
                  </div>
                  <div class="field col-12 md:col-4">
                    <label for="status">Location</label>
                    <Dropdown 
                    @change="get_location('')"
                    v-model="pick_search" 
                    :options="pick_dropdown" 
                    optionLabel="name" 
                    filter 
                    @filter="dropdown_list($event)"
                    placeholder="Select a Location" 
                    >
            <template #value="slotProps">
              <div class="country-item country-item-value" v-if="slotProps.value">
                <div>{{slotProps.value.name}}</div>
              </div>
                <span v-else>
                  {{slotProps.placeholder}}
                </span>
            </template>
            <template #option="slotProps">
              <span>{{slotProps.option.name}}</span>
            </template>
            
          </Dropdown>
                  </div>
                  
                  <div class="field col-12 md:col-2" v-if="group_type=='School'">
                    <label for="name">Mother Mobile Number</label>
                    <InputText
                      id="name"
                      type="text"
                      size="10"
                      @keypress="isNumberKey($event)"
                      v-model.trim="parent_mobile_number"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !parent_mobile_number }"
                    />
                  </div>
                  <div class="field col-12 md:col-2" v-if="group_type=='School'">
                    <label for="name">Father Mobile Number</label>
                    <InputText
                      id="name"
                      type="text"
                      size="10"
                      @keypress="isNumberKey($event)"
                      v-model.trim="alternate_parent_mobile_number"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !alternate_parent_mobile_number }"
                    />
                  </div>
                  <div class="field col-12 md:col-2" v-if="group_type=='School'">
                    <label for="name">Class</label>
                    <InputText
                      id="name"
                      type="text"
                      size="10"
                     
                      v-model.trim="Class"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !Class }"
                    />
                  </div>
                  <div class="field col-12 md:col-2" v-if="group_type=='School'">
                    <label for="name">Standard</label>
                    <InputText
                      id="name"
                      type="text"
                      size="10"
                      
                      v-model.trim="standard"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !standard }"
                    />
                  </div>
                  <div class="field col-12 md:col-2" v-if="group_type=='School'">
                    <label for="name">Roll No</label>
                    <InputText
                      id="name"
                      type="text"
                      size="10"
                      
                      v-model.trim="roll_no"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !roll_no }"
                    />
                  </div>
                  <div class="field col-12 md:col-2" v-if="group_type=='School'">
                    <label for="name">Area</label>
                    <InputText
                      id="name"
                      type="text"
                      size="10"
                      
                      v-model.trim="area"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !area }"
                    />
                  </div>
                  <div class="field col-12 md:col-2">
                    <label for="status">Stop</label>
                    <Dropdown
                      id="status"
                      v-model="stops_item"
                      :options="stops_options"
                      :value="stops_options.value"
                      optionLabel="name"
                      placeholder="Select Stops"
                      :class="{ 'p-invalid': submitted && !stops_item }"
                      required="true"
                    ></Dropdown>
                  </div>
                
            
                </div>
                <div class="grid">
                <Button
               
               label="Update"
               icon="pi pi-check"
               class="p-button-success mr-1 mb-1"
               @click="update"
             />
             <!-- File Upload -->
				        </div>
          <!-- <Button
               
               label="Import"
               icon="pi pi-table"
               class="p-button-primary mr-1 mb-1"
               @click="importuser"
             /> -->
              </div>
              </div>
       

    </Sidebar>
    <Sidebar
            v-model:visible="productDialog"
            :baseZIndex="1000"
            position="full"
          >
          <loading
      :active="isLoadingModel"
      :can-cancel="true"
      color="#173EA3"
      :is-full-page="fullPage"
    ></loading>
            <div class="col-12">
              <div class="card">
                <h5>New User</h5>
                <hr />
                <div class="p-fluid formgrid grid">
                    <div class="field col-12 md:col-4">
                      <label for="name" v-if="group_type=='School'">Student Name</label>
                    <label for="name" v-else>User Name</label>
                    <InputText
                      id="name"
                      type="text"
                      v-model.trim="name"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !name }"
                       onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)"
                    />
                  </div>
                  <div class="field col-12 md:col-2">
                    <label for="name">Mobile Number</label>
                    <InputText
                      id="name"
                      type="text"
                      maxlength="10"
                      @keypress="isNumberKey($event)"
                      v-model.trim="mobile_number"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !mobile_number }"
                    />
                  </div>
                  <div class="field col-12 md:col-2">
                    <label for="status">Select Status</label>
                    <Dropdown
                      id="status"
                      v-model="selectstatus"
                      :options="dropdownItems"
                      :value="dropdownItems.value"
                      optionLabel="name"
                      placeholder="Select One"
                      @change="change_status"
                      :class="{ 'p-invalid': submitted && !selectstatus }"
                      required="true"
                    ></Dropdown>
                  </div>
                  <div class="field col-12 md:col-4">
                    <label for="status">Location</label>
                    <Dropdown 
                    @change="get_location('')"
                    v-model="pick_search" 
                    :options="pick_dropdown" 
                    optionLabel="name" 
                    filter 
                    @filter="dropdown_list($event)"
                    placeholder="Select a Location" 
                    >
            <template #value="slotProps">
              <div class="country-item country-item-value" v-if="slotProps.value">
                <div>{{slotProps.value.name}}</div>
              </div>
                <span v-else>
                  {{slotProps.placeholder}}
                </span>
            </template>
            <template #option="slotProps">
              <span>{{slotProps.option.name}}</span>
            </template>
            
          </Dropdown>
                  </div>
                  
                  <div class="field col-12 md:col-2" v-if="group_type=='School'">
                    <label for="name">Mother Mobile Number</label>
                    <InputText
                      id="name"
                      type="text"
                      size="10"
                      @keypress="isNumberKey($event)"
                      v-model.trim="parent_mobile_number"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !parent_mobile_number }"
                    />
                  </div>
                  <div class="field col-12 md:col-2" v-if="group_type=='School'">
                    <label for="name">Father Mobile Number</label>
                    <InputText
                      id="name"
                      type="text"
                      size="10"
                      @keypress="isNumberKey($event)"
                      v-model.trim="alternate_parent_mobile_number"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !alternate_parent_mobile_number }"
                    />
                  </div>
                  <div class="field col-12 md:col-2" v-if="group_type=='School'">
                    <label for="name">Class</label>
                    <InputText
                      id="name"
                      type="text"
                      size="10"
                     
                      v-model.trim="Class"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !Class }"
                    />
                  </div>
                  <div class="field col-12 md:col-2" v-if="group_type=='School'">
                    <label for="name">Standard</label>
                    <InputText
                      id="name"
                      type="text"
                      size="10"
                      
                      v-model.trim="standard"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !standard }"
                    />
                  </div>
                  <div class="field col-12 md:col-2" v-if="group_type=='School'">
                    <label for="name">Roll No</label>
                    <InputText
                      id="name"
                      type="text"
                      size="10"
                      
                      v-model.trim="roll_no"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !roll_no }"
                    />
                  </div>
                  <div class="field col-12 md:col-2" v-if="group_type=='School'">
                    <label for="name">Area</label>
                    <InputText
                      id="name"
                      type="text"
                      size="10"
                      
                      v-model.trim="area"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !area }"
                    />
                  </div>
                  <div class="field col-12 md:col-2">
                    <label for="status">Stops</label>
                    <Dropdown
                      id="status"
                      v-model="stops_item"
                      :options="stops_options"
                      :value="stops_options.value"
                      optionLabel="name"
                      placeholder="Select Stops"
                      :class="{ 'p-invalid': submitted && !stops_item }"
                      required="true"
                    ></Dropdown>
                  </div>
                
            
                </div>
                <div class="grid">
                <Button
               
               label="ADD"
               icon="pi pi-check"
               class="p-button-success mr-1 mb-1"
               @click="adduser"
             />
             <!-- File Upload -->
				        </div>
          <!-- <Button
               
               label="Import"
               icon="pi pi-table"
               class="p-button-primary mr-1 mb-1"
               @click="importuser"
             /> -->
              </div>

              <div class="col-12">
              <div class="card">
                <div class="col-12" style="text-align:right">
                <!-- <FileUpload chooseLabel="Import"
                 label="Upload" aria-label="Upload" style="text-align:right" id="fileupload1" mode="basic" name="demo[]"   :maxFileSize="1000000" @change="fileuploaduser" />
                -->
                <FileUpload mode="basic" id="fileupload1" ref="fileupload1" chooseLabel="Import"    :maxFileSize="1000000" @change="fileuploaduser($event)" />

                <!-- <input type="file"  @change="fileuploaduser"/> -->
              </div> 
                
                  
                  <DataTable 
                  :value="products" 
                  :loading="loading"
                  :lazy="true"
                  :rows="limit"
                  :filters="filters"
                  paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                  :rowsPerPageOptions="[5, 10, 25]"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                  responsiveLayout="scroll"
                  style="font-size: 12px"
                  :rowHover="true" showGridlines>
                  
            <template #empty>
          <b style="text-align:center">No records found.</b>
        </template>
        <template #header>
              <div
                class="
                  flex flex-column
                  md:flex-row md:justify-content-between md:align-items-center
                "
              >
                <h5 class="m-0"><b> New User List</b></h5>
                Total Records:{{this.products.length}}
                
                <!-- <Button icon="pi pi-refresh" @click="search(1)" /> -->
                <!-- <span class="block mt-2 md:mt-0 p-input-icon-left">
                                  <i class="pi pi-search" />
                                  <InputText v-model="filters['global'].value" placeholder="Search..." />
                              </span> -->
              </div>
            </template>
            <Column header="Status" style="min-width: 8rem ;text-align: center;" headerStyle="min-width:2rem;" >
              <template #body="{ data }"> 
                <span v-if="data.status=='Active' ||data.status=='active'"><badge :value=data.status severity="success"></badge></span>
              <span v-else-if="data.status=='InActive' ||data.status=='In Active'"><badge :value=data.status severity="warning"></badge></span>
              <span v-else-if="data.status=='Delete' ||data.status=='Deleted'"><badge :value=data.status severity="danger"></badge></span>
              <span v-else>-</span>
              </template>
            </Column>
           
            <Column field="name" header="Name">
              <template #body="{ data }">
              
              <InputText
                      id="name"
                      type="text"
                      size="10"
                      v-model.trim="data.name"
                      required="true"
                      autofocus
                    />
              </template>
            </Column>
            <Column field="mobile_number" header="Mobile Number">
              <template #body="{ data }">
              
              <InputText
                      id="name"
                      type="text"
                      size="10"
                      @keypress="isNumberKey($event)"
                      v-model.trim="data.mobile_number"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !mobile_number }"
                    />
              </template>
            </Column>
            <!-- ------------------------------------------------------------ -->
            
            <Column field="parent_mobile_number" header="Mother Mobile Number" v-if="group_type=='School'">
              <template #body="{ data }">
              
              <InputText
                      id="name"
                      type="text"
                      size="10"
                      @keypress="isNumberKey($event)"
                      v-model.trim="data.parent_mobile_number"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !parent_mobile_number }"
                    />
              </template>
            </Column>
            <Column field="alternate_parent_mobile_number" header="Father Mobile Number" v-if="group_type=='School'">
              <template #body="{ data }">
              
              <InputText
                      id="name"
                      type="text"
                      size="10"
                      @keypress="isNumberKey($event)"
                      v-model.trim="data.alternate_parent_mobile_number"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !alternate_parent_mobile_number }"
                    />
              </template>
            </Column>
            <Column field="Class" header="Class"  v-if="group_type=='School'">
              <template #body="{ data }">
              
              <InputText
                      id="name"
                      type="text"
                      size="10"
                      @keypress="isNumberKey($event)"
                      v-model.trim="data.Class"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !Class }"
                    />
              </template>
            </Column>
            <Column field="standard" header="Standard"  v-if="group_type=='School'">
              <template #body="{ data }">
              
              <InputText
                      id="name"
                      type="text"
                      size="10"
                      @keypress="isNumberKey($event)"
                      v-model.trim="data.standard"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !standard }"
                    />
              </template>
            </Column>
            <Column field="roll_no" header="Roll No"  v-if="group_type=='School'">
              <template #body="{ data }">
              
              <InputText
                      id="name"
                      type="text"
                      size="10"
                      @keypress="isNumberKey($event)"
                      v-model.trim="data.roll_no"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !roll_no }"
                    />
              </template>
            </Column>
            
            <!-- ------------------------------------------------------------ -->
            <!-- <Column field="status" header="Status"></Column> -->
            <Column header="Location" style="text-align:left;">
              <template #body="{ data }">
                <Dropdown 
                    @change="get_location(type=data.name+data.mobile_number,data.sr_no)"
                    v-model="pick_search_array[data.name+data.mobile_number]" 
                    :options="pick_dropdown_array[data.name+data.mobile_number]" 
                    optionLabel="name" 
                    filter 
                    @filter="dropdown_list($event,[data.name+data.mobile_number])"
                    placeholder="Select a Location"
                    style="width:300px" 
                    >
                    
            <template #value="slotProps">
              <div class="country-item country-item-value" v-if="slotProps.value">
                <div>{{slotProps.value.name}}</div>
              </div>
                <span v-else>
                  {{slotProps.placeholder}}
                </span>
            </template>
            <template #option="slotProps">
              <span>{{slotProps.option.name}}</span>
            </template>
            
          </Dropdown>
          <!-- {{data}} -->
              </template>
            </Column>
            <Column field="area" header="Area"  v-if="group_type=='School'">
              <template #body="{ data }">
              
              <InputText
                      id="name"
                      type="text"
                      size="10"
                      @keypress="isNumberKey($event)"
                      v-model.trim="data.area"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !area }"
                    />
              </template>
            </Column>
            <!-- <Column field="location" header="Location"></Column> -->
            <Column header="Stops" headerStyle="min-width:2rem;">
              <template #body="{ data }">
                <Dropdown
                      id="status"
                      v-model="stops_item_array[data.name+data.mobile_number]"
                      :options="stops_options"
                      :value="stops_options.value"
                      optionLabel="name"
                      placeholder="Select Stops"
                     
                      required="true"
                    ></Dropdown>
                
              </template>
            </Column>

            <Column header="Action" headerStyle="min-width:2rem;">
              <template #body="slotProps">
               
                <Button
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-warning mt-2"
                  @click="confirmDeleteProduct(slotProps.data)"
                />
              </template>
            </Column>
        </DataTable>
        <br>
        <Button
               
               label="Submit"
               icon="pi pi-check"
               class="p-button-success mr-1 mb-1"
               @click="submit_details"
             />
                  
                
              </div>
              </div>
            </div>
            
          </Sidebar>
          
</div>
</template>

<script>
import apis from "@/apis";
import ProductService from "../../service/ProductService";
import { FilterMatchMode } from "primevue/api";
import readXlsxFile from 'read-excel-file'


export default {
  data() {
    return {
      group_user_id:'',
      stops_item:[],
      stops_options:[],
      edit_productDialog:false,
      file:[],
      limit: 10,
      filters: {},
      offset: 1,
      page_no: 1,
      list:[],

      isLoading: false,
      isLoadingModel: false,
      loading: false,
      fullPage: true,

      productDialog: false,
      table_data: [],
      place_details: "",
      pick_dropdown: [],
      pick_search: "",
      pick_search_array:[],
      pick_dropdown_array:[],


      stops_item_array:[],
      stops_options_array:[],

      name: "",
      status: "",
      location: "",
      mobile_number: "",
      parent_mobile_number:"",
      alternate_parent_mobile_number:"",
      area:"",

      products: [],
      userlist:[],

      dropdownItems: [
        { name: "Active", value: "Active" },
        { name: "InActive", value: "InActive" },
        { name: "Deleted", value: "Deleted" }
      ],
      selectstatus: { name: "", value: "" },

      productService: null
    };
  },
  props: ["group_id","group_type","groupdata"],
  methods: {
    // getgroupUserList()
    // {
    //       this.isLoadingModel=true;

    //   var data={group_id:this.group_id};
    //   var promise = apis.groupUserListget(data);
    //   promise
    //     .then(response => {
          
    //         this.isLoadingModel=false;
    //         this.list=response.data.data;
    //       }
    //     )
    // },
    update()
    {     
      var details = {
        
        name: this.name,
        mobile_number: this.mobile_number,
        parent_mobile_number:this.parent_mobile_number,
        alternate_parent_mobile_number:this.alternate_parent_mobile_number,
        Class:this.Class,
        standard:this.standard,
        area:this.area,
        roll_no:this.roll_no,
        status:  this.selectstatus.value,
        location: this.location,
         _id:this.group_user_id,
        stops_details:this.stops_item.value,
      };
     

      this.products = [];
      this.products.push(details);
      
   
      this.submit_details();
    },
    edit(data)
    { 
      this.group_user_id='';
      this.group_user_id=data._id;
      this.edit_productDialog = true;
      this.name=data.user_name;
      this.mobile_number=data.mobile_number;
      this.selectstatus={name:data.status, value:data.status};
      this.parent_mobile_number=data.parent_mobile_number;
      this.Class=data.Class;
      this.standard=data.standard;
      this.area=data.area;
      this.alternate_parent_mobile_number=data.alternate_parent_mobile_number;
      this.roll_no=data.roll_no;
      this.stops_item={name:'',value:''};
      if (data.stops_details) {
        this.stops_item={name:data.stops_details.stop_name, value:data.stops_details};
      }
      this.pick_search={ "name": data.location?data.location.Label:'', "value":data.location?data.location:''};
      this.location={ "name": data.location?data.location.Label:'', "value":data.location?data.location:''};


    },
    isNumberKey(evt) {
            evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }

  },
    fileuploaduser(event)
    {
      // alert("here");
      console.log(event);
      const input = this.$refs.fileupload1;
      // console.log(input);
      if(input.files[0].name.slice((Math.max(0, input.files[0].name.lastIndexOf(".")) || Infinity) + 1)=='xlsx')
      {
        readXlsxFile(input.files[0]).then((rows)=>{
          for(var i=1;i<rows.length;i++)
          {
            this.products.push({
        sr_no:this.products.length+1,
        name: rows[i][0],
        mobile_number: rows[i][1],
        status: "Active",
        location: "",
        parent_mobile_number:rows[i][2],
        alternate_parent_mobile_number:rows[i][3],
        Class:rows[i][4],
        standard:rows[i][5],
        roll_no:rows[i][6],
        area:rows[i][7],
        _id:'0'    
        });
          }
      })
      }
      else
      {
        alert("Please select valid file");
      }
    },
    onUpload() {
				// alert(123);
				this.$toast.add({severity: 'info', summary: 'Success', detail: 'File Uploaded', life: 3000});
			},
    getgroupUserList()
    {
          this.isLoadingModel=true;

     
      var data={group_id:this.group_id};
      var promise = apis.groupUserListget(data);
      promise
        .then(response => {
          
          this.isLoadingModel=false;
            this.list=[];
            this.list=response.data.data;
            
          }
        )
    },
    checkName(str)
    {
      if(/^[a-zA-Z ]*$/.test(str) == false)
      {
        return str;
      }
      else
      {
        return "";
      }
    },
    checkMobile(str)
    {
      if(/^[0-9]*$/.test(str) == false || str.length !=10)
      {
        return str;
      }
      else
      {
        return "";
      }
    },
    submit_details()
    { 
      if (this.products==[] || this.products==null || this.products==undefined || this.products.length==0) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Add Atlest one User",
          life: 3000
        });
        return false;
      }

    //  console.log(this.products);
      for(var i=0;i<this.products.length;i++)
      {
        if(this.products[i].name=='')
        {
          alert("Please Enter Name of user "+(i+1));
          return false;
        }
        
        if(this.products[i].mobile_number=='')
        {
          // alert(this.products[i].mobile_number.toString());
          alert("Please enter Mobile Number of user "+(i+1));
          return false;
        }
      }
      var data = {
          "users":this.products,
          "group_id":this.group_id,
          "user_id":1,
          
          };

          
         
          this.isLoadingModel = true;
          var promise = apis.addUsersToGroup(data);
          promise
            .then((responseapi) => {
              this.$swal(responseapi.data.message);
              this.isLoadingModel = false;
              this.edit_productDialog = false;
              this.productDialog = false;
              this.getgroupUserList();
            })
            .catch((error) => {
              //console.log(error);
              this.$swal.fire(error.response.data);
              this.isLoadingModel = false;
              this.edit_productDialog = false;
              this.productDialog = false;
              this.getgroupUserList();
  
              
              
            });



    },
    confirmDeleteProduct(data)
    { 
     if(confirm("Are you sure you want to delete"))
     { 
      this.products = this.products.filter(item => item.mobile_number != data.mobile_number);
     }
    },
    reset_details() {
      this.selectstatus = { name: "Active", value: "Active" };
      this.status = "";
      this.name = "";
      this.mobile_number = "";
    },
    change_status() {
      this.status = this.selectstatus.value;
    },
    async adduser() {
      
    this.change_status();
      if (!this.name) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter  Name",
          life: 3000
        });
        return false;
      }
      if (!this.mobile_number) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter  Mobile number",
          life: 3000
        });
        return false;
      }
      if (this.mobile_number.length!=10) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter valid Mobile number",
          life: 3000
        });
        return false;
      }
      if (this.group_type=='School' && this.parent_mobile_number.length!=10) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter valid Parent Mobile number",
          life: 3000
        });
        return false;
      }
      if (this.selectstatus.value=='') {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Select Status",
          life: 3000
        });
        return false;
      }
      if (
        this.location == undefined ||
        this.location == null ||
        this.location == []
      ) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Location",
          life: 3000
        });
        return false;
      }

      if (this.stops_item=[]) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Select Stop",
          life: 3000
        });
        return false;
      }

      var data = {
        sr_no:this.products.length+1,
        name: this.name,
        mobile_number: this.mobile_number,
        parent_mobile_number:this.parent_mobile_number,
        Class:this.Class,
        standard:this.standard,
        roll_no:this.roll_no,
        status: this.status,
        location: this.location,
         _id:'0',
        stops_details:this.stops_item.value,
        alternate_parent_mobile_number:this.alternate_parent_mobile_number,
        area:this.area,
      };
      console.log(data);
      // this.pick_dropdown_array.push(this.name+this.mobile_number);
      this.pick_search_array[this.name+this.mobile_number]=this.pick_search;
      this.stops_item_array[this.name+this.mobile_number]=this.stops_item;


      this.products.push(data);
       await this.reset_details();
    },
    dropdown_list(search,type='') {
      if(type=='')
      {
        var data = { search: search.value };
        this.isLoadingModel = true;
        var promise = apis.geocodelats(data);
        promise.then(response => {
          this.isLoadingModel = false;
          this.pick_dropdown = [];
          var temp = response.data.result;
          for (let a = 0; a < temp.length; a++) {
            this.pick_dropdown.push({
              name: temp[a].Text,
              value: temp[a].PlaceId
            });
          }
        });
      }
      else
      {
        var data = { search: search.value };
        this.isLoadingModel = true;
        var promise = apis.geocodelats(data);
        promise.then(response => {
          this.isLoadingModel = false;
          this.pick_dropdown_array[type] = [];
          var temp = response.data.result;
          for (let a = 0; a < temp.length; a++) {
            this.pick_dropdown_array[type].push({
              name: temp[a].Text,
              value: temp[a].PlaceId
            });
          }
        });
      }
    },
    get_location(type='',sr_no='') {
      // alert(type);
      if(type==='')
      {
        this.place_details = "";
        var data = { PlaceId: this.pick_search.value };
        this.isLoadingModel = true;
        var promise = apis.geocodelocationdetails(data);
        promise.then(response => {
          this.isLoadingModel = false;
          if (response.data.result) {
            this.place_details = response.data.result[0];
            this.location = this.place_details;
          }
        });
      }
      else
      {
        this.place_details = "";
        var data = { PlaceId: this.pick_search_array[type].value };
        this.isLoadingModel = true;
        var promise = apis.geocodelocationdetails(data);
        promise.then(response => {
          this.isLoadingModel = false;
          if (response.data.result) {
            this.place_details = response.data.result[0];
            console.log(response.data.result[0]);
            this.products[sr_no-1].location = this.place_details;
          }
        });
      }
    },
    openNew() {

      this.reset_details();
      this.product = {};
      this.products = [];
      this.submitted = false;
      this.productDialog = true;
    },
    hideDialog() {
      this.productDialog = false;
      this.submitted = false;
    },
    D_M_Y_formatDate(date_parm) {
      if (date_parm) {
        let date = new Date(date_parm);
        let dd = date.getDate();
        let mm = date.getMonth() + 1;
        let yyyy = date.getFullYear();
        let new_date = dd + "-" + mm + "-" + yyyy;
        // alert(dd)
        if (dd.toString() != "NaN") {
          //this.receipt_new_date = new_date;
          return new_date;
        } else {
          return date_parm;
        }
      }
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
      };
    }
  },
  watch:
  {
    list:
    {
           
      handler(newValue, oldValue) {
              this.userlist=this.list;
        
      }

    }
  },
  mounted() {
    // alert('here');
    // this.userlist=this.list;
    this.getgroupUserList();
  },
  async created() {
    this.productService = new ProductService();
    this.initFilters();
    if (this.groupdata && this.groupdata.stops_details && this.groupdata.stops_details.length>0) 
    {
          this.groupdata.stops_details
            .filter(item => item.stop_name)
            .map(item => this.stops_options.push({ name: item.stop_name, value: item }));
          
    }
    // this.getgroupUserList();
  }
};
</script>